import { useEffect, useRef, useState } from "react";
import styles from "./index.module.less";
import { useSetState } from "ahooks";
import message from "@/plugins/message";
import { Flex, Input, Tooltip } from "antd";
import VoiceIcon from "./imgs/voice.svg";
import RecognizingIcon from "./imgs/recognizing.webp";
import KeyboardIcon from "./imgs/keyboard.svg";
import BreakIcon from "./imgs/break.svg";
import cloneDeep from "lodash.clonedeep";
import classNames from "classnames";
import CloseIcon from "./imgs/close.svg?react";
import MuteIcon from "./imgs/mute.svg?react";
import RefreshIcon from "./imgs/refresh.svg?react";
import UnmuteIcon from "./imgs/unmute.svg?react";
import SVGIcon from "../SVGIcon";
import loadingIcon from "./imgs/loading.webp";
import ContactIcon from "./imgs/contact.svg?react";
import { useStore } from "@/stores";
import useAgent, { DialogType, EDialogStatus } from "./useAgent";
import { isMobile } from "@/utils";
import MobileAgent from "./mobile";

const Agent = ({ open, onClose }: { open: boolean; onClose?: () => void }) => {
  const {
    state,
    isReady,
    handles,
    input,
    setInput,
    inputMode,
    setInputMode,
    scrollContainer,
    rtcInstance,
    initRtc,
    asrRef,
  } = useAgent({ onClose });
  const appStore = useStore("app");
  useEffect(() => {
    if (!open) {
      handles.stopStream();
      rtcInstance.current?.destroy(false);
      isReady.current = false;
      return;
    }
    initRtc();
  }, [open]);
  return (
    <div className={styles.agent}>
      <div className="rtcContainer"></div>
      <div className={styles.humanMask}></div>
      {state.status === EDialogStatus.CONNECTING && (
        <Flex
          className={styles.loading}
          align="center"
          justify="center"
          vertical
        >
          <img src={loadingIcon} />
          接通中...
        </Flex>
      )}
      <Flex align="center" justify="end" gap={12} className={styles.topMenus}>
        <>
          <SVGIcon
            icon={<ContactIcon />}
            onClick={() => {
              appStore.openContactModal();
            }}
            style={{
              marginRight: "auto",
            }}
          />
          <Tooltip title="重置对话">
            <SVGIcon
              icon={<RefreshIcon />}
              onClick={() => {
                if (!isReady.current) {
                  message.warning("正在接通中，请稍后再试");
                  return;
                }
                handles.stopStream();
                rtcInstance.current?.destroy(false);
                isReady.current = false;
                initRtc();
              }}
            />
          </Tooltip>
          <SVGIcon
            icon={<CloseIcon />}
            onClick={() => {
              if (!isReady.current) {
                message.warning("正在接通中，请稍后再试");
                return;
              }
              onClose?.();
            }}
          />
        </>
        {/* )} */}
      </Flex>
      <div className={styles.bottom}>
        <div className={styles.bottomMask}></div>
        <div
          className={classNames(styles.chatListWrap, {
            [styles["withMask"]]: false,
          })}
        >
          <div className={styles.chatList} ref={scrollContainer}>
            {state.chatList
              .filter((row) => !!row.content)
              .map((item, index) => (
                <div
                  key={index}
                  className={classNames(styles.chatItem, {
                    [styles.question]: item.type === DialogType.ASK,
                    [styles.answer]: item.type === DialogType.ANSWER,
                  })}
                >
                  <div className={styles.question}>{item.content}</div>
                </div>
              ))}
          </div>
        </div>
        <Flex
          align="center"
          gap={".08rem"}
          className={classNames(styles.bottomMenus, {
            [styles.disabled]: state.status === EDialogStatus.CONNECTING,
          })}
        >
          <div className={styles.inputWrap}>
            {inputMode === "keyboard" ? (
              <Input
                placeholder={
                  state.status === EDialogStatus.THINKING
                    ? "正在思考..."
                    : "发消息..."
                }
                value={input}
                onChange={(e) => setInput(e.target.value)}
                onPressEnter={() => {
                  if (!input) {
                    message.warning("请输入消息内容");
                    return;
                  }
                  handles.send(input);
                  setInput("");
                }}
              />
            ) : (
              <div className={styles.recognizingIcon}>
                <img src={RecognizingIcon} />
              </div>
            )}
            <Tooltip title="打断数字人">
              <img
                src={BreakIcon}
                className={styles.breakTalking}
                onClick={handles.break}
              />
            </Tooltip>
          </div>
          {inputMode === "keyboard" ? (
            <img
              src={VoiceIcon}
              onClick={() => {
                if (state.status === EDialogStatus.CONNECTING) {
                  message.warning("正在接通中，请稍后再试");
                  return;
                }
                setInputMode("voice");
                handles.asrStart();
              }}
              className={styles.toggleMode}
            />
          ) : (
            <img
              src={KeyboardIcon}
              onClick={() => {
                if (state.status === EDialogStatus.CONNECTING) {
                  message.warning("正在接通中，请稍后再试");
                  return;
                }
                setInputMode("keyboard");
                asrRef.current?.stop();
              }}
              className={styles.toggleMode}
            />
          )}
        </Flex>
      </div>
    </div>
  );
};
export default isMobile() ? MobileAgent : Agent;
